import { AutoCloseWarning } from '@/components/alerts/AutoCloseWarning';
import { ReturnForRevisionModal } from '@/features/tasks/task-overlays/ReturnForRevisionModal';
import { ResultRequiredModal } from '@/features/tasks/task-overlays/ResultRequiredModal';
import { TaskExtensionModal } from '@/features/tasks/task-dialogs/TaskExtensionModal';
import { TaskSelectionModal } from '@/features/tasks/task-dialogs/TaskSelectionModal';
import { TimeUpModal } from '@/features/tasks/task-overlays/TimeUpModal';
import { env } from '@/shared/config';
import { useAuthStore, useIsNativeSession } from '@/store/auth';

/**
 * Глобальные модалки рабочего процесса — висят в корне приложения, поэтому
 * монтируются на любой странице, включая `/login` и `/register`.
 *
 * Внутри они безусловно тянут данные: `useTaskSelectionModalLogic` и
 * `TimeUpModal` вызывают `useAllTasks()`, то есть полную выборку `/tasks/list`.
 * До появления нативной авторизации это просто было незаметно, а теперь:
 *  - на публичных страницах запрос уходит ещё до входа;
 *  - под нативной сессией уходит в удалённую legacy-группу `/tasks` (404).
 *
 * Поэтому монтируем их только там, где они осмысленны: пользователь вошёл, и
 * вошёл по старой сессии Bitrix24, на которой этот функционал и построен.
 * Их переезд на `/v2/tasks` — отдельная задача (фаза 5 плана).
 */
export function AppGlobalOverlays() {
  const isAuthenticated = useAuthStore(
    (state) => env.authBypass || state.isAuthenticated
  );
  const isNativeSession = useIsNativeSession();

  if (!isAuthenticated || isNativeSession) {
    return null;
  }

  return (
    <>
      <AutoCloseWarning />
      <TaskExtensionModal />
      <TimeUpModal />
      <ResultRequiredModal />
      <ReturnForRevisionModal />
      <TaskSelectionModal />
    </>
  );
}
